import gsap from 'gsap'

export default function() {
  const html = document.querySelector('html')
  const hamburgers = document.querySelectorAll('.header-hamburger')

  let isActive = false

  gsap.set('.menu', { visibility: 'hidden' })

  const menuTL = gsap
    .timeline({
      paused: true,
      defaults: { duration: 0.8, ease: 'customEase' },
    })
    .call(() => {
      html.classList.toggle('overflow-hidden')
      html.classList.toggle('menu-open')
      isActive = !isActive
      gsap.set('.menu', { visibility: isActive ? 'visible' : 'hidden' })
    })
    .fromTo(
      '.menu',
      {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)',
      },
      {
        clipPath: 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)',
      }
    )

    .fromTo(
      '.menu-img',
      {
        scale: 1.4,
      },
      {
        scale: 1,
      },
      '<'
    )

    .fromTo(
      '.menu-translate-text',
      {
        translateX: '-50%',
      },
      {
        translateX: '0%',
        duration: 1.5,
      },
      '<'
    )
    .fromTo(
      '.menu-socials',
      {
        y: gsap.getProperty('[fade]', 'y', 'px'),
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        stagger: 0.1,
      },
      '<25%'
    )
    .fromTo(
      '.center-menu-item',
      {
        y: gsap.getProperty('[fade]', 'y', 'px'),
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        stagger: 0.1,
      },
      '<'
    )
    .fromTo(
      '.menu-left-fade',
      {
        y: gsap.getProperty('[fade]', 'y', 'px'),
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
        stagger: 0.1,
      },
      '<25%'
    )

  hamburgers.forEach(hamburger => {
    hamburger.addEventListener('click', toggleMenu)
  })
  function toggleMenu() {
    if (menuTL.paused() || menuTL.reversed()) {
      menuTL.timeScale(1)
      menuTL.resume()
    } else {
      menuTL.timeScale(1.7)
      menuTL.reversed(!menuTL.reversed())
    }
  }
}
